// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.admin tr th:first-child {
  width: 220px;
}

table.admin tr th:last-child,
table.admin tr td:last-child {
  padding-left: 12px;
}

.fixed_headers > thead,
.fixed_headers > tbody,
.fixed_headers > thead > tr,
.fixed_headers > tbody > tr,
.fixed_headers > thead > tr > th,
.fixed_headers > tbody > tr > td {
  display: block;
}

.fixed_headers > thead > tr > th,
.fixed_headers > tbody > tr > td {
  float: left;
}

#mainList,
.mainList {
  position: relative !important;
  top: 160px !important;
}

::ng-deep .fixed_headers .mat-table-sticky {
  top: 160px !important;
}

::ng-deep .fixed_headers thead tr.mat-header-row {
  height: 28px;
}

::ng-deep .fixed_headers thead tr.mat-header-row th {
  background-color: rgb(113, 113, 113);
  color: #FDFDFD;
}

::ng-deep .fixed_headers th.mat-header-cell:first-of-type,
::ng-deep .fixed_headers .mat-row td:first-of-type {
  padding-left: 3px;
}

::ng-deep .fixed_headers tr.mat-row {
  height: 28px;
}

::ng-deep .fixed_headers .mat-sort-header-arrow {
  color: #ffffff;
}

::ng-deep .fixed_headers .dateByDefault .mat-sort-header-arrow,
::ng-deep .fixed_headers .ascDate .mat-sort-header-arrow {
  transform: translateY(0px) !important;
  opacity: 1 !important;
}

::ng-deep .fixed_headers .dateByDefault .mat-sort-header-arrow .mat-sort-header-indicator {
  transform: translateY(10px) !important;
}

::ng-deep .fixed_headers .dateByDefault .mat-sort-header-arrow .mat-sort-header-pointer-left {
  transform: rotate(45deg) !important;
}

::ng-deep .fixed_headers .dateByDefault .mat-sort-header-arrow .mat-sort-header-pointer-right {
  transform: rotate(-45deg) !important;
}

@media only screen and (max-device-width: 823px) and (min-device-width: 320px) {
  ::ng-deep .fixed_headers .mat-cell {
    font-family: "MontserratLight", sans-serif;
    font-size: 12px;
  }
  ::ng-deep .fixed_headers .mat-cell:not(.ngorange) {
    color: #6a6a6a;
  }
}
.mat-darkGrayIcon {
  background: #666666 !important;
}

.mat-grayIcon {
  background: #aaaaaa !important;
}

.mat-orangeIcon {
  background: rgb(227, 94, 36) !important;
}

::ng-deep .fixed_headers .mat-mini-fab {
  width: 25px;
  height: 25px;
  line-height: 24px;
}

::ng-deep .fixed_headers .mat-mini-fab .mat-button-wrapper {
  line-height: 10px;
  font-size: 12px;
  color: white;
}

tbody tr:hover {
  background-color: rgb(246, 246, 246);
}

tbody tr.noResult:hover {
  background-color: inherit;
}

tr td,
tr th {
  height: 28px;
}

tr td:last-child,
tr th:last-child {
  border-right: 0;
}

table.fixed_headers tr th,
table.fixed_headers tr td {
  text-align: left;
}

tr td {
  padding: 0;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

td.noResult {
  padding: 0;
  cursor: default;
  text-align: center !important;
  height: 350px;
  font-size: 125%;
}

.truncate {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

td {
  border-bottom: 1px solid #DDD;
}

td.noBorder {
  border-bottom: none;
}

thead {
  background-color: #333;
  color: #FDFDFD;
}

.cards_container {
  margin: 170px auto 0 auto;
}

.orderingPair {
  position: relative;
  padding-left: 10px;
  top: -3px;
}

.selectedItem {
  background-color: rgb(236, 236, 236);
}

.mat-darkGrayIcon {
  background: #666666 !important;
}

.mat-grayIcon {
  background: #aaaaaa !important;
}

.mat-orangeIcon {
  background: rgb(227, 94, 36) !important;
}

.bred {
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  margin: 5px;
  color: white;
  background-color: rgb(240, 123, 126);
}

.byellow {
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  margin: 5px;
  color: white;
  background-color: rgb(238, 207, 123);
}

.bgreen {
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  margin: 5px;
  color: white;
  background-color: rgb(119, 198, 175);
}

.bblack {
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  margin: 5px;
  color: white;
  background-color: rgb(191, 191, 191);
}

::ng-deep .fixed_headers .mat-header-row.search {
  opacity: 0.999;
}

::ng-deep .fixed_headers .mat-mini-fab {
  width: 25px;
  height: 25px;
  line-height: 24px;
}

::ng-deep .fixed_headers .mat-mini-fab .mat-button-wrapper {
  line-height: 10px;
  font-size: 12px;
  color: white;
}

tr.mat-mdc-header-row {
  height: 28px !important;
}

.mat-mdc-table .mat-mdc-header-cell {
  background: #717171 !important;
  color: #fdfdfd !important;
  max-width: 200px !important;
}

.mat-sort-header-content {
  text-align: left !important;
}

.mdc-data-table__header-cell {
  padding: 0 16px 0 3px !important;
}

.mat-mdc-header-row {
  font-family: "MontserratLight", sans-serif !important;
  font-weight: bold !important;
  font-size: 12px !important;
  line-height: 1.5em !important;
}

.mat-mdc-row {
  height: 28px !important;
  padding-left: 3px !important;
}
.mat-mdc-row .mat-mdc-cell {
  padding-left: 3px !important;
}

.mat-mdc-table {
  overflow: visible !important;
}

.mat-mdc-header-row {
  position: sticky;
  top: 160px;
  z-index: 1;
  background-color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/main-list/components/web/main-list/main-list.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEA;;EAEI,kBAAA;AACJ;;AAEA;;;;;;EAMI,cAAA;AACJ;;AAGA;;EAEI,WAAA;AAAJ;;AAGA;;EAEI,6BAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,qBAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,cAAA;AAAJ;;AAGA;;EAEI,iBAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAIA;;EAEI,qCAAA;EACA,qBAAA;AADJ;;AAIA;EACI,sCAAA;AADJ;;AAIA;EACI,mCAAA;AADJ;;AAIA;EACI,oCAAA;AADJ;;AAIA;EACI;IACI,0CAAA;IACA,eAAA;EADN;EAIE;IACI,cAAA;EAFN;AACF;AAKA;EACI,8BAAA;AAHJ;;AAMA;EACI,8BAAA;AAHJ;;AAMA;EACI,uCAAA;AAHJ;;AAMA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,iBAAA;EACA,eAAA;EACA,YAAA;AAHJ;;AAMA;EACI,oCAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;;EAEI,YAAA;AAHJ;;AAMA;;EAGI,eAAA;AAJJ;;AAOA;;EAEI,gBAAA;AAJJ;;AAOA;EACI,UAAA;EACA,eAAA;EAEA,mBAAA;EACA,uBAAA;EACA,gBAAA;AALJ;;AAQA;EACI,UAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;AALJ;;AAQA;EACI,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AALJ;;AAQA;EACI,6BAAA;AALJ;;AAQA;EACI,mBAAA;AALJ;;AAQA;EACI,sBAAA;EACA,cAAA;AALJ;;AAQA;EACI,yBAAA;AALJ;;AASA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;AANJ;;AASA;EACI,oCAAA;AANJ;;AASA;EACI,8BAAA;AANJ;;AASA;EACI,8BAAA;AANJ;;AASA;EACI,uCAAA;AANJ;;AAUA;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;AAPJ;;AAUA;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;AAPJ;;AAUA;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;AAPJ;;AAUA;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;AAPJ;;AAUA;EACI,cAAA;AAPJ;;AAUA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,iBAAA;EACA,eAAA;EACA,YAAA;AAPJ;;AAWA;EACI,uBAAA;AARJ;;AAWA;EACI,8BAAA;EACA,yBAAA;EACA,2BAAA;AARJ;;AAWA;EACI,2BAAA;AARJ;;AAWA;EACI,gCAAA;AARJ;;AAWA;EACI,qDAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;AARJ;;AAWA;EACI,uBAAA;EACA,4BAAA;AARJ;AAUI;EACI,4BAAA;AARR;;AAYA;EACI,4BAAA;AATJ;;AAYA;EACI,gBAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;AATJ","sourcesContent":["table.admin tr th:first-child {\n    width: 220px;\n}\n\ntable.admin tr th:last-child,\ntable.admin tr td:last-child {\n    padding-left: 12px;\n}\n\n.fixed_headers>thead,\n.fixed_headers>tbody,\n.fixed_headers>thead>tr,\n.fixed_headers>tbody>tr,\n.fixed_headers>thead>tr>th,\n.fixed_headers>tbody>tr>td {\n    display: block;\n}\n\n\n.fixed_headers>thead>tr>th,\n.fixed_headers>tbody>tr>td {\n    float: left;\n}\n\n#mainList,\n.mainList {\n    position: relative !important;\n    top: 160px !important;\n}\n\n::ng-deep .fixed_headers .mat-table-sticky {\n    top: 160px !important;\n}\n\n::ng-deep .fixed_headers thead tr.mat-header-row {\n    height: 28px;\n}\n\n::ng-deep .fixed_headers thead tr.mat-header-row th {\n    background-color: rgb(113, 113, 113);\n    color: #FDFDFD;\n}\n\n::ng-deep .fixed_headers th.mat-header-cell:first-of-type,\n::ng-deep .fixed_headers .mat-row td:first-of-type {\n    padding-left: 3px;\n}\n\n::ng-deep .fixed_headers tr.mat-row {\n    height: 28px;\n}\n\n::ng-deep .fixed_headers .mat-sort-header-arrow {\n    color: #ffffff;\n}\n\n\n::ng-deep .fixed_headers .dateByDefault .mat-sort-header-arrow,\n::ng-deep .fixed_headers .ascDate .mat-sort-header-arrow {\n    transform: translateY(0px) !important;\n    opacity: 1 !important;\n}\n\n::ng-deep .fixed_headers .dateByDefault .mat-sort-header-arrow .mat-sort-header-indicator {\n    transform: translateY(10px) !important;\n}\n\n::ng-deep .fixed_headers .dateByDefault .mat-sort-header-arrow .mat-sort-header-pointer-left {\n    transform: rotate(45deg) !important;\n}\n\n::ng-deep .fixed_headers .dateByDefault .mat-sort-header-arrow .mat-sort-header-pointer-right {\n    transform: rotate(-45deg) !important;\n}\n\n@media only screen and (max-device-width: 823px) and (min-device-width: 320px) {\n    ::ng-deep .fixed_headers .mat-cell {\n        font-family: \"MontserratLight\", sans-serif;\n        font-size: 12px;\n    }\n\n    ::ng-deep .fixed_headers .mat-cell:not(.ngorange) {\n        color: #6a6a6a;\n    }\n}\n\n.mat-darkGrayIcon {\n    background: #666666 !important;\n}\n\n.mat-grayIcon {\n    background: #aaaaaa !important;\n}\n\n.mat-orangeIcon {\n    background: rgb(227, 94, 36) !important;\n}\n\n::ng-deep .fixed_headers .mat-mini-fab {\n    width: 25px;\n    height: 25px;\n    line-height: 24px;\n}\n\n::ng-deep .fixed_headers .mat-mini-fab .mat-button-wrapper {\n    line-height: 10px;\n    font-size: 12px;\n    color: white;\n}\n\ntbody tr:hover {\n    background-color: rgb(246, 246, 246);\n}\n\ntbody tr.noResult:hover {\n    background-color: inherit;\n}\n\ntr td,\ntr th {\n    height: 28px;\n}\n\ntr td:last-child,\ntr th:last-child {\n\n    border-right: 0;\n}\n\ntable.fixed_headers tr th,\ntable.fixed_headers tr td {\n    text-align: left;\n}\n\ntr td {\n    padding: 0;\n    cursor: pointer;\n\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\ntd.noResult {\n    padding: 0;\n    cursor: default;\n    text-align: center !important;\n    height: 350px;\n    font-size: 125%;\n}\n\n.truncate {\n    margin: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\ntd {\n    border-bottom: 1px solid #DDD;\n}\n\ntd.noBorder {\n    border-bottom: none;\n}\n\nthead {\n    background-color: #333;\n    color: #FDFDFD;\n}\n\n.cards_container {\n    margin: 170px auto 0 auto;\n\n}\n\n.orderingPair {\n    position: relative;\n    padding-left: 10px;\n    top: -3px;\n}\n\n.selectedItem {\n    background-color: rgb(236, 236, 236);\n}\n\n.mat-darkGrayIcon {\n    background: #666666 !important;\n}\n\n.mat-grayIcon {\n    background: #aaaaaa !important;\n}\n\n.mat-orangeIcon {\n    background: rgb(227, 94, 36) !important;\n}\n\n\n.bred {\n    text-align: center;\n    border-radius: 5px;\n    padding: 5px;\n    margin: 5px;\n    color: white;\n    background-color: rgb(240, 123, 126);\n}\n\n.byellow {\n    text-align: center;\n    border-radius: 5px;\n    padding: 5px;\n    margin: 5px;\n    color: white;\n    background-color: rgb(238, 207, 123);\n}\n\n.bgreen {\n    text-align: center;\n    border-radius: 5px;\n    padding: 5px;\n    margin: 5px;\n    color: white;\n    background-color: rgb(119, 198, 175);\n}\n\n.bblack {\n    text-align: center;\n    border-radius: 5px;\n    padding: 5px;\n    margin: 5px;\n    color: white;\n    background-color: rgb(191, 191, 191);\n}\n\n::ng-deep .fixed_headers .mat-header-row.search {\n    opacity: 0.999;\n}\n\n::ng-deep .fixed_headers .mat-mini-fab {\n    width: 25px;\n    height: 25px;\n    line-height: 24px;\n}\n\n::ng-deep .fixed_headers .mat-mini-fab .mat-button-wrapper {\n    line-height: 10px;\n    font-size: 12px;\n    color: white;\n}\n\n// Overide mdc component styles\ntr.mat-mdc-header-row {\n    height: 28px !important;\n}\n\n.mat-mdc-table .mat-mdc-header-cell {\n    background: #717171 !important;\n    color: #fdfdfd !important;\n    max-width: 200px !important;\n}\n\n.mat-sort-header-content {\n    text-align: left !important;\n}\n\n.mdc-data-table__header-cell {\n    padding: 0 16px 0 3px !important;\n}\n\n.mat-mdc-header-row {\n    font-family: \"MontserratLight\", sans-serif !important;\n    font-weight: bold !important;\n    font-size: 12px !important;\n    line-height: 1.5em !important;\n}\n\n.mat-mdc-row {\n    height: 28px !important;\n    padding-left: 3px !important;\n\n    .mat-mdc-cell {\n        padding-left: 3px !important;\n    }\n}\n\n.mat-mdc-table {\n    overflow: visible !important;\n}\n\n.mat-mdc-header-row {\n    position: sticky;\n    top: 160px;\n    z-index: 1;\n    background-color: inherit;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
